import { useEffect } from "react";

interface OutsideClickHandlerProps {
  ref: React.RefObject<HTMLElement>;
  handler: () => void;
}

const useOutsideClick = ({ ref, handler }: OutsideClickHandlerProps) => {
  /**
   * Sets up a mousedown event listener to detect clicks outside the referenced element.
   * Triggers the handler when a click is detected outside the element boundaries.
   * Cleans up the event listener on unmount.
   */
  useEffect(
    function handleOutsideClick() {
      const handleClickOutside = (event: MouseEvent) => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          handler();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    [ref, handler]
  );
};

export default useOutsideClick;
